import { Plan } from 'types'
import { usePaginationHandler, getShopId } from 'utils'

export const planQuery = `
    id
    planId
    title
    name
    description
    price
    maxLocations
    maxServices
    maxResources
    maxGroupAppointmentsSlots
    maxFlows
    maxUsers
    maxTokens
    listed
`

//usePlans:
export const usePlans = (search: string | null, limit: number) => {
    const shopId = getShopId()
    return usePaginationHandler<Plan[]>({
        query: `
            query getPlans(
                $shop: String,
                $searchTerm: String,
                $limit: Int!,
                $after: String,
                $before: String
            ){
                getPlans(
                    shop: $shop,
                    searchTerm: $searchTerm,
                    limit: $limit,
                    after: $after,
                    before: $before
                ){

                    data{
                        ${planQuery}
                        activationUrl
                    }

                    totalItems
                    remainingItems
                    nextCursor
                    previousCursor

                }
            }
        `,
        variables: {
            shop: shopId,
            searchTerm: search,
            limit,
            after: null,
            before: null
        },
        cacheKey: ['plans', shopId],
        limit,
        getResponse: json => json.data.getPlans,
        onSuccess: response => response.data
    })
}
